import { apiClient } from './api'

export interface DashboardStats {
  projects: {
    total: number
    growthPercentage: number
  }
  assets: {
    total: number
    growthPercentage: number
  }
  scans: {
    total: number
    growthPercentage: number
  }
  vulnerabilities: {
    total: number,
    growthPercentage: number
  }
}

export interface VulnerabilityStats {
  byStatus: {
    FIXED: number
    NOT_FIXED: number
    READY_TO_REVALIDATE: number
    OUT_OF_SCOPE: number
  }
  bySeverity: {
    INFO: number
    LOW: number
    MEDIUM: number
    HIGH: number
    CRITICAL: number
  }
}

export interface DashboardData {
  overview: DashboardStats
  vulnerabilities: VulnerabilityStats
  filters: {
    tenantId?: string
    startDate: string
    endDate: string
  }
}

export interface DashboardParams {
  tenantId?: string
  startDate?: string
  endDate?: string
}

class DashboardApi {
  async getDashboardData(params: DashboardParams = {}) {
    const queryParams = new URLSearchParams()
    
    if (params.tenantId) {
      queryParams.append('tenantId', params.tenantId)
    }
    if (params.startDate) {
      queryParams.append('startDate', params.startDate)
    }
    if (params.endDate) {
      queryParams.append('endDate', params.endDate)
    }

    const url = `/projects-service/api/v1/projects/dashboard-data${
      queryParams.toString() ? `?${queryParams.toString()}` : ''
    }`

    return apiClient.get<DashboardData>(url, undefined, 'PROJECTS')
  }
}

export const dashboardApi = new DashboardApi()

